"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunction = void 0;
const isFunction = (x) => typeof x === "function";
exports.isFunction = isFunction;
